import { render, staticRenderFns } from "./IscrizioniAttivitaAllievo.vue?vue&type=template&id=a941ac90&scoped=true&"
import script from "./IscrizioniAttivitaAllievo.vue?vue&type=script&lang=ts&"
export * from "./IscrizioniAttivitaAllievo.vue?vue&type=script&lang=ts&"
import style0 from "./IscrizioniAttivitaAllievo.vue?vue&type=style&index=0&id=a941ac90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a941ac90",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardText,VCol,VIcon,VRow})
